/*=========================================================================================
  File Name: state.js
  Description: Phone Service Store Main File
  ----------------------------------------------------------------------------------------
  Item Name: Phone Service Store Module
  Author: Tan Tran
==========================================================================================*/

import state from './state'
import mutations from './mutations'
import getters from './getters'
import actions from './actions'
export default {
    namespaced: true,
    state : state,
    mutations : mutations,
    actions : actions,
    getters : getters
}